<template >
  <v-container>
    <base-material-card :renderCard="card" color="secondary" icon="mdi-file-tree">
      <template v-slot:after-heading>
        <div class="display-1 mt-2 font-weight-light">{{ $t("edit_pdc") }}</div>
      </template>
      <v-container>
        <v-row>
          <v-col md="3" cols="12">
            <v-text-field v-model="searchPdc" :label="$t('search_pdc')" flat hide-details @keyup="updateTree(true)"
              @click:clear="updateTree(false)" clearable clear-icon="mdi-close-circle-outline"></v-text-field>

            <v-treeview class="pdcTree" ref="pdcTree" v-model="tree" :items="pdcTree" :search="searchPdc" :open="open"
              activatable item-key="keyId" item-text="descr" item-children="child" hoverable :active.sync="activePdc"
              :open-on-click="false">
              <template v-slot:prepend="{ item, open }">
                <v-icon v-if="item.type === 'R'" color="primary">{{ "mdi-file-tree" }}</v-icon>
                <v-icon v-if="item.mastrAuto === 'U'" color="primary">{{
                  "mdi-account-multiple"
                }}</v-icon>
                <v-icon v-else-if="item.mastrAuto === 'M'" color="primary">{{
                  "mdi-handshake-outline"
                }}</v-icon>
                <v-icon v-else-if="item.ifPrimaNota"
                  :color="item.attivo === 1 || (item.child && item.child.length > 0) ? 'primary' : 'error'">{{ "mdi-bank"
                  }}</v-icon>
                <v-icon v-else color="primary">{{
                  open ? "mdi-folder-open" : "mdi-folder"
                }}</v-icon>
              </template>
              <template slot="label" slot-scope="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <a v-on="on">
                      {{ item.descr }}
                      <span v-if="item.saldo && item.saldo > 0" class="success--text">{{ item.saldo }} €</span>
                      <span v-if="item.saldo && item.saldo < 0" class="error--text">{{ item.saldo }} €</span>
                    </a>
                  </template>
                  <span>{{ item.descr }} {{ item.saldo }}</span>
                </v-tooltip>
              </template>
            </v-treeview>
            <v-col v-if="
              selectedPdc &&
              selectedPdc.type !== 'D' &&
              (!selectedPdc.mastrAuto || selectedPdc.mastrAuto === '')
            " cols="12" class="text-center">
              <v-btn v-if="!selectedPdc.ifNew" class="mx-5" @click="createFiglio(selectedPdc)" color="primary">
                <span v-if="selectedPdc.type === 'R'">{{
                  $t("new_mastro")
                }}</span>
                <span v-else-if="selectedPdc.type === 'M'">{{
                  $t("new_sottomastro")
                }}</span>
                <span v-else-if="
                  selectedPdc.type === 'S' && selectedPdc.mastrAuto === ''
                ">{{ $t("new_dettaglio") }}</span>
              </v-btn>
            </v-col>
          </v-col>
          <v-col md="9" cols="12">
            <v-row v-if="selectedPdc && selectedPdc.type === 'M'">
              <v-col cols="10">
                <v-text-field v-model="selectedPdc.descr" :label="$t('description')" flat :rules="required"
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-checkbox :disabled="selectedPdc.usato" :false-value="false" :true-value="true"
                  v-model="selectedPdc.ifPrimaNota" :label="$t('if_prima_nota')"></v-checkbox>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn class="mx-5" @click="savePdc(selectedPdc)" color="success">{{ selectedPdc.ifNew ? $t("create") :
                  $t("save") }}</v-btn>
                <v-btn class="mx-5" v-if="
                  selectedPdc.child.length === 0 &&
                  !selectedPdc.usato &&
                  !selectedPdc.ifNew
                " @click="deletePdc(selectedPdc)" color="error">{{ $t("delete") }}</v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedPdc && selectedPdc.type === 'S'">
              <v-col v-if="selectedPdc.ifPrimaNota" cols="4">
                <v-checkbox :false-value="false" :true-value="true" v-model="selectedPdc.ifRaggruppabile"
                  :label="$t('if_raggrupable')"></v-checkbox>
              </v-col>
              <v-col v-if="selectedPdc.ifPrimaNota" cols="4">
                <v-text-field v-model="selectedPdc.serieEntrate" :label="$t('serie_entry')" flat
                  hide-details></v-text-field>
              </v-col>
              <v-col v-if="selectedPdc.ifPrimaNota" cols="4">
                <v-text-field v-model="selectedPdc.serieUscite" :label="$t('serie_exit')" flat
                  hide-details></v-text-field>
              </v-col>
              <v-col v-if="!selectedPdc.ifPrimaNota" cols="4">
                <v-select v-model="selectedPdc.mastrAuto" item-value="code" item-text="descr" :items="typePdc"
                  :disabled="selectedPdc.usato" required color="primary" persistent-hint></v-select>
              </v-col>
              <v-col v-if="!selectedPdc.ifPrimaNota" cols="4">
                <v-checkbox :false-value="false" :true-value="true" v-model="selectedPdc.ifFornitori"
                  :label="$t('if_supplier')"></v-checkbox>
              </v-col>
              <v-col v-if="!selectedPdc.ifPrimaNota" cols="4">
                <v-checkbox :false-value="false" :true-value="true" v-model="selectedPdc.generaRicevute"
                  :label="$t('if_gen_receipt')"></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="selectedPdc.descr" :label="$t('description')" :rules="required" flat
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn class="mx-5" @click="savePdc(selectedPdc)" color="success">{{ selectedPdc.ifNew ? $t("create") :
                  $t("save") }}</v-btn>
                <v-btn class="mx-5" v-if="
                  selectedPdc.child.length === 0 &&
                  !selectedPdc.usato &&
                  !selectedPdc.ifNew
                " @click="deletePdc(selectedPdc)" color="error">{{ $t("delete") }}</v-btn>
              </v-col>
            </v-row>
            <div v-if="selectedPdc && selectedPdc.type === 'D'">
              <form>
                <v-row>
                  <v-col cols="8">
                    <v-text-field v-model="selectedPdc.ragSoc" :label="$t('ragSoc')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col> <v-col cols="2">
                    <v-switch :true-value="1" :false-value="0" v-model="selectedPdc.attivo"
                      :label="$t(selectedPdc.attivo === 1 ? 'active_m_s' : 'disabled_m_s')"></v-switch>
                  </v-col><v-col cols="2">
                    <my-datepicker v-if="selectedPdc.attivo === 0" v-model="selectedPdc.dateClose"
                      :label="$t('date_close')" />
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field v-model="selectedPdc.name" :label="$t('name')" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field v-model="selectedPdc.surname" :label="$t('surname')" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-radio-group row v-model="selectedPdc.sex">
                      <v-radio :label="$t('male')" value="M"></v-radio>
                      <v-radio :label="$t('female')" value="F"></v-radio>
                      <v-radio :label="$t('company')" value=" "></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field v-model="selectedPdc.cFiscale" :label="$t('fiscal_code')"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field v-model="selectedPdc.pIva" :label="$t('pIva')" hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6" cols="12">
                    <v-text-field v-model="selectedPdc.birthCity" :label="$t('birth_city')"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="2" cols="6">
                    <v-text-field v-model="selectedPdc.birthProv" :label="$t('birth_province')"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="6">
                    <my-datepicker v-model="selectedPdc.birthDate" :label="$t('birth_date')" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="6" cols="12">
                    <v-text-field v-model="selectedPdc.email" :label="$t('email_address')" :rules="requiredEmail"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field v-model="selectedPdc.telephone" :label="$t('telephone')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="12" cols="12">
                    <v-text-field v-model="selectedPdc.resStreet" :label="$t('residence_address')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field v-model="selectedPdc.resCity" :label="$t('residence_city')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="4" cols="4">
                    <v-text-field v-model="selectedPdc.resCountry" :label="$t('country')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="2" cols="4">
                    <v-text-field v-model="selectedPdc.resCAP" :label="$t('postal_code')" :rules="requiredNumber"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="2" cols="4">
                    <v-text-field v-model="selectedPdc.resProv" :label="$t('province')" :rules="required"
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="selectedPdc.ifPrimaNota">
                    <v-autocomplete v-model="selectedPdc.userAssigned" :items="selectUsers" item-text="text"
                      item-value="value" dense :label="$t('owner_user')"></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-btn v-if="!selectedPdc.ifNew" class="mx-5" @click="prtEstrattoConto(selectedPdc)"
                      color="primary">{{ $t("print_account_balance") }}</v-btn>
                    <v-btn class="mx-5" @click="savePdc(selectedPdc)" color="success">{{
                      selectedPdc.ifNew ? $t("create") : $t("save")
                    }}</v-btn>
                    <v-btn class="mx-5" v-if="!selectedPdc.usato && !selectedPdc.ifNew" @click="deletePdc(selectedPdc)"
                      color="error">{{ $t("delete") }}</v-btn>
                  </v-col>
                </v-row>
              </form>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "gest-pdc",
  props: {
    cauId: null,
    method: null,
    card: true,
  },
  components: { MyDatepicker },
  data() {
    return {
      pdcTree: [],
      pdcList: [],
      selectedUsers: [],
      activePdc: [],
      tree: [],
      open: [],
      typePdc: [
        { code: "M", descr: this.$t("pdc_myASD") },
        { code: "U", descr: this.$t("pdc_users") },
        { code: "", descr: this.$t("pdc_contab") },
      ],
      searchPdc: null,
      required: [(value) => !!value || this.$t("required")],
      requiredEmail: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
      requiredDate: [(value) => !!value || "Required."],
    };
  },
  methods: {
    updateTree(mode) {
      if (mode && this.searchPdc && this.searchPdc !== "")
        this.$refs.pdcTree.updateAll(true);
      else {
        this.$refs.pdcTree.updateAll(false);
      }
    },
    loadData() {
      let _ = this;
      _.isFetching = true;
      //_.pdcTree = [];
      _.activePdc = [];
      //_.pdcList = [];
      _.chiamataAxios("GET", "/auth/contab/treeMastriContabili").then(
        (response) => {
          _.pdcTree = [
            {
              keyId: null,
              type: "R",
              descr: "root",
              child: response.data.tree,
            },
          ];
          _.pdcList = response.data.list;
          _.pdcList.unshift({
            keyId: null,
            type: "R",
            descr: "root",
            child: [],
          });
        }
      );
    },
    prtEstrattoConto(item) {
      let url =
        "/auth/contab/pdf/estrattoConto/" +
        item.mastrCge +
        "/" +
        item.sotmaCge +
        "/" +
        item.dettaCge;
      this.$documentViewer.documentViewerRsp.docUrl = url;
    },
    createFiglio(pdc) {
      let figlio = {};
      let keyId =
        Math.max.apply(
          Math,
          this.pdcList.map(function (o) {
            return o.keyId;
          })
        ) + 1;
      if (pdc.type === "R")
        figlio = {
          keyId: keyId,
          ifNew: true,
          ifPrimaNota: false,
          type: "M",
          child: [],
        };
      if (pdc.type === "M")
        figlio = {
          keyId: keyId,
          ifNew: true,
          mastrAuto: "",
          ifPrimaNota: pdc.ifPrimaNota,
          type: "S",
          mastrCge: pdc.mastrCge,
          child: [],
        };
      if (pdc.type === "S")
        figlio = {
          keyId: keyId,
          ifNew: true,
          ifPrimaNota: pdc.ifPrimaNota,
          type: "D",
          mastrCge: pdc.mastrCge,
          sotmaCge: pdc.sotmaCge,
          child: [],
        };
      this.pdcList.push(figlio);
      this.activePdc[0] = keyId;
    },
    deletePdc(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        customClass: "v-application",
        showCancelButton: true,
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          let url = "/auth/contab/deletePdc/" + item.type + "/" + item.mastrCge;
          if (item.type === "S")
            url =
              "/auth/contab/deletePdc/" +
              item.type +
              "/" +
              item.mastrCge +
              "/" +
              item.sotmaCge;
          if (item.type === "D")
            url =
              "/auth/contab/deletePdc/" +
              item.type +
              "/" +
              item.mastrCge +
              "/" +
              item.sotmaCge +
              "/" +
              item.dettaCge;
          _.chiamataAxios("DELETE", url, {
            dialogLoader: true,
            body: item,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
            }
          });
        }
      });
    },
    savePdc: function (item) {
      let _ = this;
      let url = "/auth/contab/updatePdc/" + item.type + "/" + item.mastrCge;
      if (item.type === "S")
        url =
          "/auth/contab/updatePdc/" +
          item.type +
          "/" +
          item.mastrCge +
          "/" +
          item.sotmaCge;
      if (item.type === "D")
        url =
          "/auth/contab/updatePdc/" +
          item.type +
          "/" +
          item.mastrCge +
          "/" +
          item.sotmaCge +
          "/" +
          item.dettaCge;
      let operaz = "POST";
      if (item.ifNew) {
        url = "/auth/contab/createPdc/" + item.type;
        operaz = "PUT";
      }

      _.chiamataAxios(operaz, url, { dialogLoader: true, body: item }).then(
        (response) => {
          if (response.msg.esito) {
            let html = "<strong>" + response.msg.msgTxt + "</strong>"
            Swal.fire({
              type: "success",
              html: html,
            });
            _.loadData();
          }
        }
      );
    },
  },
  mounted() {
    this.loadData();

    let url = "/auth/portal/listUsers";
    let filter = { filter: { type: "tutti" } };
    let _ = this;
    _.selectUsers = [];
    this.chiamataAxios("POST", url, { body: filter }).then((response) => {
      _.selectUsers = response.data.map(function (item) {
        return {
          value: item.masterId,
          text:
            item.surname +
            " " +
            item.name +
            "   -   " +
            item.resCity +
            " (" +
            item.eta +
            " anni)",
        };
      });
      _.selectUsers.push({ value: null, text: _.$t("nobody_m") });
    });
  },
  computed: {
    selectedPdc() {
      if (!this.activePdc.length) return undefined;
      const id = this.activePdc[0];
      return this.pdcList.find((pdc) => {
        return pdc.keyId === id;
      });
    },
  },
};
</script>
<style scoped>
.pdcTree {
  max-height: 60vh;
  overflow: auto;
}
</style>